import { render, staticRenderFns } from "./tickets.vue?vue&type=template&id=9f62dcd0&scoped=true"
import script from "./tickets.vue?vue&type=script&lang=js"
export * from "./tickets.vue?vue&type=script&lang=js"
import style0 from "./tickets.vue?vue&type=style&index=0&id=9f62dcd0&prod&lang=css"
import style1 from "./tickets.vue?vue&type=style&index=1&id=9f62dcd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../Users/wencesszelagowski/Downloads/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f62dcd0",
  null
  
)

export default component.exports